import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./EditOrder.css";

const EditOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [formData, setFormData] = useState({
    paymentStatus: "",
    orderStatus: "",
  });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_SERVER}/api/orders/${id}`)
      .then((res) => {
        setOrder(res.data);
        setFormData({
          paymentStatus: res.data.paymentStatus || "",
          orderStatus: res.data.orderStatus || "",
        });
      })
      .catch((err) => console.error("Failed to load order", err));
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_SERVER}/api/orders/${id}`,
        formData
      );
      alert("Order updated successfully");
      navigate("/admin/orders");
    } catch (err) {
      console.error(err);
      alert("Failed to update order");
    }
  };

  if (!order) return <p>Loading...</p>;

  return (
    <div className="edit-order-container">
      <h2>Edit Order (ID: {order._id})</h2>
      <form onSubmit={handleSubmit}>
        <div className="formGroup">
          <label>Payment Status:</label>
          <select
            name="paymentStatus"
            value={formData.paymentStatus}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Paid">Paid</option>
            <option value="Pending">Pending</option>
            <option value="Failed">Failed</option>
          </select>
        </div>

        <div className="formGroup">
          <label>Order Status:</label>
          <select
            name="orderStatus"
            value={formData.orderStatus}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Processing">Processing</option>
            <option value="Shipped">Shipped</option>
            <option value="Delivered">Delivered</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>

        <button type="submit" className="submit-btn">
          Update Order
        </button>
      </form>
    </div>
  );
};

export default EditOrder;
